<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!expenseSelected) {
        <h1 class="title">Crear gasto</h1>
      }
    </div>
    <div class="title-color">
      @if (expenseSelected) {
        <h1 class="title">Editar gasto</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="expenseForm" (ngSubmit)="saveExpense()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Unidad</mat-label>
              <input
                type="text"
                matInput
                placeholder="Unidad"
                formControlName="unity"
                maxlength="150"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (expenseForm.get('unity')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (expenseForm.get('unity')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 150 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Paquete</mat-label>
              <input
                type="number"
                matInput
                placeholder="Paquete"
                formControlName="package"
                required
              />
              @if (expenseForm.get('package')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Valor</mat-label>
              <input type="number" matInput placeholder="Valor" formControlName="value" required />
              @if (expenseForm.get('value')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Cantidad</mat-label>
              <input type="number" matInput placeholder="Cantidad" formControlName="qty" required />
              @if (expenseForm.get('qty')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Total</mat-label>
              <input type="number" matInput placeholder="Total" formControlName="total" required />
              @if (expenseForm.get('total')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!expenseForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
